import {
  REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE,
  REMOTE_IMAGE_ACTIVE_STATUS_TYPE,
} from '../../../constants/service/app/remoteImageConstants';

/**
 *  원격 스플래시 이미지 검색 옵션 모델
 */
export const REMOTE_IMAGE_SPLASH_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  메모
   */
  memo: null,
  /**
   *  원격 이미지 생성일
   */
  createDate: null,
};

/**
 *  원격 레퍼럴 이미지 검색 옵션 모델
 */
export const REMOTE_IMAGE_REFERRAL_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  노출위치 타입
   */
  exposeLocationType: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  원격 이미지 생성일
   */
  createDate: null,
};

/**
 *  원격 스플래시 이미지 상세 정보(생성/수정) 모델
 */
export const REMOTE_IMAGE_SPLASH_DETAIL_MODEL = {
  remoteImg: [],
  memo: null,
  imgUrl: null,
  status: REMOTE_IMAGE_ACTIVE_STATUS_TYPE.ACTIVE,
  originStatus: REMOTE_IMAGE_ACTIVE_STATUS_TYPE.ACTIVE,
};

/**
 *  원격 레퍼럴 이미지 상세 정보(생성/수정) 모델
 */
export const REMOTE_IMAGE_REFERRAL_DETAIL_MODEL = {
  exposeLocationTypeEditable: true,
  exposeLocationType: REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.MY_PAGE,
  memo: null,
  linkType: null,
  linkId: null,
  appImg: [],
  pcImg: [],
  tabletImg: [],
  mobileImg: [],
  appImgUrl: null,
  pcImgUrl: null,
  tabletImgUrl: null,
  mobileImgUrl: null,
  status: REMOTE_IMAGE_ACTIVE_STATUS_TYPE.ACTIVE,
  originStatus: REMOTE_IMAGE_ACTIVE_STATUS_TYPE.ACTIVE,
};
